import { apiServerRoutes } from "constants/apiRoutes";
import { getAPICallServer } from "utils/axios.util";

class DocumentService {
  async fetchAll(req: any) {
    const { page } = req.body;
    return getAPICallServer(
      `${apiServerRoutes.DOCUMENTS}?page_no=${page || 1}`,
      req
    );
  }
}

export default new DocumentService();
